export default "/images/incoming-emails.svg?d379ad21e0b9c402ec6f61bc34b1e91d";